import FlutterPackage from "../../../../contents/docs/integrate/client/flutter/snippets/package.mdx";
import FlutterInstall from "../../../../contents/docs/integrate/client/flutter/snippets/install.mdx";
import * as React from 'react';
export default {
  FlutterPackage,
  FlutterInstall,
  React
};